module.exports = __webpack_public_path__ + "img/phone-call.f84ccc92.svg";